
<template>
    <div class="hygiene-opportunities">
        <b-navbar class="px-2" toggleable="md" type="dark" variant="primary">
            <b-navbar-brand href="#">Hygiene Opportunities</b-navbar-brand>
            <b-navbar-toggle class="ml-auto" target="nav_collapse3"></b-navbar-toggle>
            <b-collapse is-nav id="nav_collapse3">
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <b-nav-item href="#">
                <button type="button" id="close-tooltip" class="btn mr-xs btn-default btn-sm" @click="closeSlideOutPanel"><i class="la la-remove"></i></button>
                <b-tooltip target="close-tooltip" triggers="hover">
                    Close
                </b-tooltip>
                </b-nav-item>                
            </b-navbar-nav>
            </b-collapse>
        </b-navbar>

        <div class="mt-3">
            <PopupErrorDisplay/>
        </div>

        <HygieneOpportunitiesSkeleton v-if="loading" />

        <div v-if="this.dataToDisplay" v-show="!loading">
            <b-row v-if="category === 'unscheduledFamilyRecalls'">
                <b-col lg="8" xs="12">
                <Widget>
                    <h3>Unscheduled Family <span class="fw-semi-bold">Recalls</span></h3>
                    <p>These are patients who are family members of patients on your schedule today that <span class="fw-semi-bold">that DO NOT have a recall appointment scheduled!</span></p>
                    <v-client-table v-if="unscheduledFamilyRecallsData" :data="unscheduledFamilyRecallsData" :columns="unscheduledFamilyRecallsColumns" :options="unscheduledFamilyRecallsOptions">
                        <div slot="h__UnscheduledRecallPatient">Unscheduled Recall Patient</div>
                        <div slot="h__LastRecallDate">Last Recall Date</div>
                        <div slot="h__RecallDue">Recall Due</div>
                        <div slot="h__RelatedPatientOnSchedule">Related Patient on Schedule</div>
                        <div slot="h__Operatory">Operatory</div>

                        <div slot="UnscheduledRecallPatient" slot-scope="props">
                            <a href="#" @click="gotoPatientPage(props.row.PatNum)">{{props.row.UnscheduledRecallPatient}}</a>
                        </div>

                        <div slot="LastRecallDate" slot-scope="props">
                            <b-badge variant="default" class="fw-semi-bold" pill v-if="props.row.LastRecallDate === null">No History</b-badge>
                            <span v-else>{{props.row.LastRecallDate | dateformat(dateFormatStr)}}</span>
                        </div> 

                        <div slot="RecallDue" slot-scope="props">
                            <span v-if="props.row.RecallDue === null"> </span>
                            <span v-else>{{props.row.RecallDue| dateformat(dateFormatStr)}}</span>
                        </div>

                        <div slot="RelatedPatientOnSchedule" slot-scope="props">
                            <a href="#" @click="gotoPatientPage(props.row.RelatedPatientOnSchedulePatNum)">{{props.row.RelatedPatientOnSchedule}}</a>
                        </div>
                    </v-client-table>                     
                </Widget>
                </b-col>
            </b-row>

            <b-row v-if="category === 'xrays'">
                <b-col lg="6" xs="12">
                <Widget>
                    <h3>Patients due for <span class="fw-semi-bold">PANO/FMX</span></h3>
                    <p>These are patients on your schedule for hygiene <span class="fw-semi-bold">that may be due</span> for PANO/FMX, and <span class="fw-semi-bold">may possibly be eligible</span> by their insurance!</p>
                    <p>Teamio has no way (not yet) of pulling patient's prior history of procedures done at <span class="fw-semi-bold">ANOTHER PRACTICE</span></p>
                    <p><span class="fw-semi-bold">Last PANO/FMX: </span> Last date of PANO/FMX in patient's chart in Open Dental. If it's blank, it means a PANO/FMX has not been taken in your practice. </p>
                    <p><span class="fw-semi-bold">PANO / FMX Frequency: </span> Frequency of PANO/FMX as allowed by the patient's Insurance. If it's blank, it means there isn't an Insurance plan attached to the patient OR a frequency is NOT entered in patient's Insurance Benefit.  </p>
                    <p><span class="fw-semi-bold">Date Due: </span> Next due date of patient's PANO/FMX. If it's blank, it is not set up yet by Open Dental. </p>

                    <v-client-table v-if="panoXraysData" :data="panoXraysData" :columns="panoXraysColumns" :options="panoXraysOptions">
                    <div slot="h__Patient">Patient</div>
                    <div slot="h__Operatory">Operatory</div>
                    <div slot="h__LastPanoDate">Last PANO/FMX</div>
                    <div slot="h__PanoFmxFrequency">PANO/FMX Frequency</div>
                    <div slot="h__DateDue">Date Due</div>
                    <div slot="h__Elligible">Eligible</div>

                    <div slot="Patient" slot-scope="props">
                        <a href="#" @click="gotoPatientPage(props.row.PatNum)">{{props.row.Patient}}</a>
                    </div>

                    <div slot="LastPanoDate" slot-scope="props">
                        <b-badge variant="default" class="fw-semi-bold" pill v-if="props.row.LastPanoDate === null">No History</b-badge>
                        <span v-else>{{props.row.LastPanoDate | dateformat(dateFormatStr)}}</span>
                        <!-- ** commenting this out for now since whether the procedure is pano/fmx is off right now. **
                                data is correct, just the procdcure code is off. Future fix would be pull a separate column in the pano/fmx
                                query for "Last Pano Date", "Last FMX date", "PANO Due date", "FMX due date",
                                but will worry about this if it comes up or requested by users. 
                                Rigth now all that matters is the date of last PANO/fMX since they're usually shared by almost all insurances
                            <span class="text-success fw-semi-bold" v-if="getProcTypeForPanoFmx(props.row.Procedures) !== ''"> ({{getProcTypeForPanoFmx(props.row.Procedures)}}) </span>
                        -->
                    </div>

                    <div slot="PanoFmxFrequency" slot-scope="props">
                        <span v-if="props.row.PanoFmxFrequency === null"> </span>
                        <span v-else>{{props.row.PanoFmxFrequency}}</span>
                    </div>

                    <div slot="DateDue" slot-scope="props">
                        <span v-if="props.row.DateDue === null || props.row.DateDue === '0001-01-01' || props.row.DateDue === '1901-01-01'"> </span>
                        <span v-else>{{props.row.DateDue | dateformat(dateFormatStr)}}</span>
                        <p v-if="props.row.Ordinal === 2">
                        <small>
                            <span class="text-muted"><em>(secondary Ins.)</em></span>
                        </small>
                        </p>
                    </div>

                    <div slot="Elligible" slot-scope="props">
                        <b-tooltip class="tool_tip" :target="`panoelligible-${props.row.PatNum}`" placement="righttop" triggers="hover">
                            Eligible
                        </b-tooltip>
                        <b-tooltip class="tool_tip" :target="`exclamation-${props.row.PatNum}`" placement="righttop" triggers="hover">
                            Unable to determine eligibility by insurance. Please make sure to check prior hx at another office if no history of the procedure in your practice!
                        </b-tooltip>
                        <span class="glyphicon glyphicon-ok text-success fw-semi-bold" v-if="isPanoElligible(props.row)" :id="`panoelligible-${props.row.PatNum}`"></span>
                        <span class="fa fa-exclamation text-warning fw-semi-bold" :id="`exclamation-${props.row.PatNum}`" v-else></span>
                    </div>
                    </v-client-table>                     
                </Widget>
                </b-col>
                <b-col lg="6" xs="12">
                <Widget>
                    <h3>Patients due for <span class="fw-semi-bold">BW Xrays</span></h3>
                    <p>These are patients on your schedule for hygiene <span class="fw-semi-bold">that are due</span> for BWs and <span class="fw-semi-bold">they're ELIGIBLE</span> by their insurance!</p>

                    <v-client-table v-if="bwXraysData" :data="bwXraysData" :columns="bwXraysColumns" :options="bwXraysOptions">
                    <div slot="h__Patient">Patient</div>
                    <div slot="h__Operatory">Operatory</div>
                    <div slot="h__LastBWDate">Last BWs</div>
                    <div slot="h__BwFrequency">BW Frequency</div>
                    <div slot="h__DateDue">Date Due</div>
                    <div slot="h__Elligible">Eligible</div>

                    <div slot="Patient" slot-scope="props">
                        <a href="#" @click="gotoPatientPage(props.row.PatNum)">{{props.row.Patient}}</a>
                    </div>
                    
                    <div slot="LastBWDate" slot-scope="props">
                        <b-badge variant="default" class="fw-semi-bold" pill v-if="props.row.LastBWDate === null">No History</b-badge>
                        <span v-else>{{props.row.LastBWDate | dateformat(dateFormatStr)}}</span>
                    </div>

                    <div slot="DateDue" slot-scope="props">
                        <span v-if="props.row.DateDue === null || props.row.DateDue === '0001-01-01' || props.row.DateDue === '1901-01-01'"> </span>
                        <span v-else>{{props.row.DateDue | dateformat(dateFormatStr)}}</span>
                    </div>

                    <div slot="Elligible" slot-scope="props">
                        <span class="glyphicon glyphicon-ok text-success fw-semi-bold" v-if="isBwElligible(props.row)" :id="`bwelligible-${props.row.PatNum}`"></span>
                        <span class="fa fa-exclamation text-warning fw-semi-bold" :id="`bwexclamation-${props.row.PatNum}`" v-else></span>
                        <b-tooltip class="tool_tip" :target="`bwelligible-${props.row.PatNum}`" placement="righttop" triggers="hover">
                            Eligible
                        </b-tooltip>
                        <b-tooltip class="tool_tip" :target="`bwexclamation-${props.row.PatNum}`" placement="righttop" triggers="hover">
                            Unable to determine eligibility by insurance. Please make sure to check prior hx at another office if no history of the procedure in your practice!
                        </b-tooltip>
                    </div>                        
                    </v-client-table>                    
                </Widget>
                </b-col>
            </b-row>
            
            <b-row v-if="category === 'unscheduledTx'">
                <b-col lg="8" xs="12">
                <Widget>
                    <h3>Unscheduled <span class="fw-semi-bold">Treatment</span></h3>
                    <p>This is a list of patients who have come in for hygiene appointment today that have <span class="fw-semi-bold"> unscheduled treatment</span></p>
                    <p><span class="fw-semi-bold">Note: </span>It will <span class="fw-semi-bold">not</span> show a patient if they have an appointment scheduled within the next 60 days in the office.</p>

                    <v-client-table v-if="unscheduledTxData" :data="unscheduledTxData" :columns="unscheduledTxColumns" :options="unscheduledTxOptions">
                    <div slot="h__Patient">Patient on Schedule</div>
                    <div slot="h__Operatory">Operatory</div>
                    <div slot="h__AmountRemaining">Benefit Remaining On Insurance</div>
                    <div slot="h__TotalBalance">Balance On Account</div>

                    <div slot="Patient" slot-scope="props">
                        <a href="#" @click="gotoPatientPage(props.row.PatNum)">{{props.row.Patient}}</a>
                    </div>

                    <div slot="AmountRemaining" slot-scope="props">
                        {{props.row.AmountRemaining | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}
                    </div>
                    <div slot="TotalBalance" slot-scope="props">
                        <span class="text-success fw-semi-bold" v-if="props.row.TotalBalance === 0">{{props.row.TotalBalance | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span>
                        <span class="text-danger fw-semi-bold" v-if="props.row.TotalBalance > 0">{{props.row.TotalBalance | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}</span>
                        <span class="text-grey fw-semi-bold" v-if="props.row.TotalBalance < 0">({{props.row.TotalBalance | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}})</span>
                        
                    </div>

                    </v-client-table>                    
                </Widget>
                </b-col>
            </b-row>
            
            <b-row v-if="category === 'orthoBenefits'">
                <b-col lg="8" xs="12">
                <Widget>
                    <h3><span class="fw-semi-bold">Orthodontic Benefits</span></h3>
                    <p>This is a list of patients who are on your schedule that have <span class="fw-semi-bold">Orthodontic Benefits.</span> </p>

                    <v-client-table v-if="orthoBenefitsData" :data="orthoBenefitsData" :columns="orthoBenefitsColumns" :options="orthoBenefitsOptions">
                    <div slot="h__Patient">Patient</div>
                    <div slot="h__Age">Age</div>
                    <div slot="h__OrthoCoverage">Ortho Coverage</div>
                    <div slot="h__AgeLimit">Age Limit</div>
                    <div slot="h__OrthoMax">Ortho Max</div>
                    <div slot="h__OpName">Operatory</div>

                    <div slot="Patient" slot-scope="props">
                        <a href="#" @click="gotoPatientPage(props.row.PatNum)">{{props.row.Patient}}</a>
                    </div>

                    <div slot="OrthoCoverage" slot-scope="props">
                        <span class="glyphicon glyphicon-ok text-success fw-semi-bold" v-if="props.row.OrthoCoverage === 'YES'"></span>
                        <span v-if="props.row.OrthoCoverage === 'NO'">NO</span>
                    </div>

                    <div slot="OrthoMax" slot-scope="props">
                        {{props.row.OrthoMax | money(allSettings.GENERAL_CURRENCY_SYMBOL.PropertyValue)}}
                    </div>
                    </v-client-table>
                    <div v-else>No data found!</div>
                </Widget>
                </b-col>
            </b-row>
        </div>        
    </div>
</template>

<script>
/* eslint-disable */

import Widget from "@/components/Widget/Widget";
import PopupErrorDisplay from "@/components/ErrorDisplay/PopupErrorDisplay";
import HygieneOpportunitiesSkeleton from "./HygieneOpportunitiesSkeleton.vue";
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import mixin from '@/mixin.js';
import moment from 'moment-timezone';

export default {
  name: 'HygieneOpportunities',
  components: { Widget, PopupErrorDisplay, HygieneOpportunitiesSkeleton },
  props: ['category'],
  mixins: [mixin],  

  created() {
    if(this.allSettings)
      this.init();
  },

  mounted() {
    //this.initCharts();
  },

  data() {
    return {
        loading: true,
        results: [],
        unscheduledFamilyRecallsColumns: ['UnscheduledRecallPatient', 'LastRecallDate', 'RecallDue', 'RelatedPatientOnSchedule', 'Operatory'],
        panoXraysColumns: ['Patient', 'Operatory', 'LastPanoDate', 'PanoFmxFrequency', 'DateDue', 'Elligible'],
        bwXraysColumns: ['Patient', 'Operatory', 'LastBWDate', 'BwFrequency', 'DateDue', 'Elligible'],
        unscheduledTxColumns: ['Patient', 'Operatory', 'AmountRemaining', 'TotalBalance'],
        orthoBenefitsColumns: ['Patient', 'Age', 'OrthoCoverage', 'AgeLimit', 'OrthoMax', 'OpName'],
        unscheduledFamilyRecallsOptions: {
            filterable: false,
            skin:'table',
            sortable: [],
            perPage: 10,
            sortByColumn: false,
            pagination: { chunk: 10, dropdown: false },
        },
        options: {
            filterable: [],
            skin:'table',
            sortable: [],
            perPage: 10,
            sortByColumn: false,
            pagination: { chunk: 10, dropdown: false },
        },
        panoXraysOptions: {
            filterable: [],
            skin:'table',
            sortable: [],
            perPage: 10,
            sortByColumn: false,
            pagination: { chunk: 10, dropdown: false },
        },
        bwXraysOptions: {
            filterable: [],
            skin:'table',
            sortable: [],
            perPage: 10,
            sortByColumn: false,
            pagination: { chunk: 10, dropdown: false },
        },
        unscheduledTxOptions: {
            filterable: [],
            skin:'table',
            sortable: [],
            perPage: 10,
            sortByColumn: false,
            pagination: { chunk: 10, dropdown: false },
        },
        orthoBenefitsOptions: {
            filterable: [],
            skin:'table',
            sortable: [],
            perPage: 10,
            sortByColumn: false,
            pagination: { chunk: 10, dropdown: false },
        },
    }
  },

  methods: {
      ...mapActions('huddle', ['getHygieneOpportunities']),

    async init() {
        this.loading = true;
        this.resetError();
        try {
            if(this.category) {
                let payload = {
                    siteID: this.siteID,
                    _date: this.$route.query.d ? this.$route.query.d : moment().format('YYYY-MM-DD'),
                    country: localStorage.getItem('country') || 'USA',
                    category: this.category
                };
                this.results = await this.getHygieneOpportunities(payload);
            } else {
                console.error('Category missing for Hygiene Opportunities');
            }
        } finally {
            this.loading = false;
        }
    },

    isPanoElligible(row) {
      let d = this.$route.query.d ? this.$route.query.d : moment().format('YYYY-MM-DD');
      if(row.LastPanoDate !== null && moment().diff(row.LastPanoDate, 'days') > 0 && moment().diff(row.DateDue, 'days') >= 0)
        return true;
      else
        return false;
    },

    isBwElligible(row) {
      let d = this.$route.query.d ? this.$route.query.d : moment().format('YYYY-MM-DD');
      if(row.LastBWDate !== null && moment().diff(row.LastBWDate, 'days') > 0 && moment().diff(row.DateDue, 'days') >= 0)
        return true;
      else
        return false;
    },

    async closeSlideOutPanel() {            
        let returnResults = {
            test : false           
        } 
        this.$emit('closePanel',returnResults);
    },

    gotoPatientPage(patNum) {
      let teamioPatientID = `${this.siteID}-${patNum}`;
      let routeData = this.$router.resolve({name: 'patientprofile', params: {patientID:  teamioPatientID}});
      window.open(routeData.href, '_blank');
    },
  },

  computed: {

    dataToDisplay() {
      if(this.results && this.results.data && this.results.data.length > 0)
          return this.results.data;
    },
      
    unscheduledFamilyRecallsData() {
      if(this.dataToDisplay) {
        return this.dataToDisplay;
      }
    },

    panoXraysData() {
      if(this.dataToDisplay) {
        return this.dataToDisplay[0];
      }
    },

    bwXraysData() {
      if(this.dataToDisplay) {
        return this.dataToDisplay[1];
      }
    },

    unscheduledTxData() {
      if(this.dataToDisplay) {
        return this.dataToDisplay;
      }
    },

    orthoBenefitsData() {
      if(this.dataToDisplay) {
        return this.dataToDisplay;
      }
    },
  }
};

</script>

<style src="./HuddleComponentsModern.scss" lang="scss" />
